





















import { Component, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import AppBar from "@/components/for-page-grid/AppBar.vue";
import Cookies from "@/components/hoc/Cookies.vue";
import Sidebar from "@/components/for-page-grid/Sidebar.vue";
import StackCaptcha from "@/components/captcha/StackCaptha.vue";
import VueRecaptcha from "vue-recaptcha";

@Component({
  components: {
    VueRecaptcha,
    StackCaptcha,
    AppBar,
    Sidebar,
    Cookies,
  },
  computed: {
    ...mapState({
      auth: "auth",
      dialog: "dialog",
      cookies: "cookies",
    })
  },
})
class App extends Vue {
  [x: string]: any;

  /*
    Использовать свойство topCssProp при работе со всплывающими элементами страницы,
    такими как, поупап или слайдер, с целью контроля текущих координат пользователя
    по оси Y, что позволяет "сохранить" позицию пользователя при закртыии указанных
    элементов
  */
  topCssProp = { value: 0, valuePx: "" };

  public get stackCaptha() {
    return process.env && process.env.VUE_APP_CAPTCHA === "StackCaptha";
  }

  public get loggedIn(): boolean {
    return this.auth.loggedIn;
  }

  public get isOpenDialog(): boolean {
    return this.dialog.isOpen;
  }

  public get isHelpPage(): boolean {
    return this.$route.path.startsWith('/help');
  }

  @Watch("loggedIn")
  public loggedInChanged() {
    if (!this.loggedIn) {
      this.$router.push({ name: "auth" });
    }
  }

  @Watch("isOpenDialog")
  public isOpenDialogChanged() {
    if (this.dialog.isOpen) {
      const top = window.pageYOffset;

      this.topCssProp.value = top;
      this.topCssProp.valuePx = top ? `-${top}px` : "";
    }
  }

  updated() {
    const top = this.topCssProp.value;
    window.scroll({ top });
  }

  public get cookiesConfirmed(): boolean {
    return this.cookies.confirmed;
  }
}

export default App;
